import { LineItemStatus } from '../../apis/graphql/types';

export const LINE_ITEMS_STATUSES = {
  draft: 'DRAFT',
  ready: 'READY',
  live: 'LIVE',
  pending: 'PENDING_APPROVAL',
  paused: 'PAUSED',
  suspended: 'SUSPENDED',
  complete: 'COMPLETE',
  cancel: 'CANCELLED',
};

export const DELETABLE_STATUS = LINE_ITEMS_STATUSES.draft;

export const CANCELLABLE_STATUSES = [
  LINE_ITEMS_STATUSES.pending,
  LINE_ITEMS_STATUSES.ready,
  LINE_ITEMS_STATUSES.live,
  LINE_ITEMS_STATUSES.paused,
];

export const DOWNLOADABLE_STATUSES = [
  LINE_ITEMS_STATUSES.complete,
  LINE_ITEMS_STATUSES.cancel,
  LINE_ITEMS_STATUSES.suspended,
];

export const EDITABLE_STATUSES = [
  LINE_ITEMS_STATUSES.draft,
  LINE_ITEMS_STATUSES.ready,
  LINE_ITEMS_STATUSES.live,
  LINE_ITEMS_STATUSES.paused,
  LINE_ITEMS_STATUSES.pending,
];

export const PAUSABLE_STATUSES = [LINE_ITEMS_STATUSES.ready, LINE_ITEMS_STATUSES.live];

export const RESUMABLE_STATUSES = [LINE_ITEMS_STATUSES.paused];

export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

export const SUSPENDABLE_STATUSES: string[] = [
  LineItemStatus.PendingApproval,
  LineItemStatus.Ready,
  LineItemStatus.Live,
  LineItemStatus.Paused,
];

export const TOOLTIPS = {
  preemptible: {
    title: 'Preemptible line item',
    description:
      'Inventory availability for preemptible line items is determined at time of Ad delivery and is not guaranteed. If you want to ensure there is available inventory to run your line item, select to run your line item without the preemptible option.',
  },
};
